import { Box } from '@wix/design-system';
import { STUDIO_SECTION_DIVIDER_COLOR } from '@wix/package-picker-shared-studio';
import React from 'react';

export const FaqDivider = () => (
  <Box
    width="100%"
    marginTop="72px"
    marginBottom="48px"
    borderTop={`1px solid ${STUDIO_SECTION_DIVIDER_COLOR}`}
  />
);
